import * as React from 'react';
import { Link } from 'react-router-dom';

type NavTileStates = 'enabled' | 'disabled' | 'loading';

interface INavTileProps extends React.PropsWithChildren {
	type?: 'primary' | 'standard';
	label?: string;
	to?: string;
	state?: NavTileStates;
	additionalClasses?: string[];
	icon?: string;

	onClick?: (e: React.UIEvent<HTMLAnchorElement>) => void;
}

const primaryTitleSrc = (label: string) => `/92b3b47/assets/icons/navigation/${label.replace(/\s/g, '').toLowerCase()}.svg`;

const primaryTile = (props: INavTileProps) => {
	return <div className="nav-tile__icon">
		{props.label ?
			<img
				className="nav-tile__icon-img"
				src={primaryTitleSrc(props.icon ? props.icon : props.label)}
				alt={props.icon ? props.icon : props.label}></img>
			:
			<img className="nav-tile__icon-img no-label" src="/92b3b47/assets/images/logo-black.png" alt={props.to}></img>
		}
	</div>;
};

const standardTile = (props: INavTileProps) => {
	return <div className="nav-tile__row">
		<div className="nav-tile__link__label">{props.label}</div>
	</div>;
};

export const NavTile: React.FC<INavTileProps> = (props) => {
	const type = props.type || 'standard';

	const isDisabled = props.state === 'disabled';
	const isLoading = props.state === 'loading';

	const outerClasses: string[] = [
		isDisabled ? 'nav-tile__disabled' : 'nav-tile',
		`nav-tile__${type}`,
		...props.additionalClasses || []
	];

	const outerClass = outerClasses.join(' ');

	const linkClass =
		isDisabled ? 'nav-tile__link disabled-link' :
			isLoading ? 'disabled-link' :
				`nav-tile__link ${type === 'primary' && 'nav-tile__link-primary'} `;

	return <Link className={linkClass} to={props.to || '/'} onClick={props.onClick}>
		<div className={outerClass}>
			{type === 'primary' ?
				primaryTile(props) :
				standardTile(props)
			}
		</div>
		{type === 'primary' ? <p className="nav-tile__primary-label">{props.label}</p> : null}
	</Link>;
};
